import React from "react";
import GoogleMapReact from "google-map-react";

const GoogleMap = ({ children, ...props }) => {
  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  return (
    <div style={{ width: "100%", height: "60vh" }}>
      <GoogleMapReact
        resetBoundsOnResize
        bootstrapURLKeys={{
          key: apiKey,
        }}
        {...props}
      >
        {children ? children : []}
      </GoogleMapReact>
    </div>
  );
};

export default GoogleMap;
